import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { queueSearchSchema } from "@/features/admin-queues/api";
import { QueuesPage } from "@/features/admin-queues/QueuesPage";
function Page() {
  const { session } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <QueuesPage actorId={session.user.id} search={search} navigate={next => void navigate({ search: next })} />;
}
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/queues")({
  validateSearch: (search: Record<string, unknown>) => queueSearchSchema.parse(search),
  search: { middlewares: [stripSearchParams(queueSearchSchema.parse({}))] },
  component: Page,
});
